import { propOr } from 'ramda'

import ProgramCard from '@/components/cards/program'

import Meta from './components/meta'
import usePrograms, { withProgramsStore } from './stores/use-programs'

const programsSelector = propOr([], 'programs')

const ProgramListing = () => {
  const programs = usePrograms(programsSelector)

  return (
    <div className='h-bg-intr align-center flex h-[100%] min-h-full flex-wrap bg-theme-turquoise px-5'>
      <div className='mt-[-5px] ml-[-10px] flex-[0_0_100%] scale-[.8]'>
        <Meta />
        <div className='mx-auto max-w-[700px] '>
          <div className='program-listing'>
            {programs.map((program, i) => (
              <ProgramCard
                program={program}
                key={program.id}
                tailDirection={i % 2 ? 'right' : 'left'}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default withProgramsStore(ProgramListing)
